export default {
  groupNamePlaceholder: 'Nombre del grupo',
  addMembers: 'Agrega a los participantes del grupo',
  searchPlaceholder: 'Buscar por Nombre o Correo Electrónico',
  createGroup: 'Crear grupo',
  editGroup: 'Editar grupo'
}

export const en = {
  groupNamePlaceholder: 'Group name',
  addMembers: 'Add group participants',
  searchPlaceholder: 'Search by Name or Email',
  createGroup: 'Create group',
  editGroup: 'Edit group'
}

export const ca = {
  groupNamePlaceholder: 'Nom del grup',
  addMembers: 'Afegeix els participants del grup',
  searchPlaceholder: 'Buscar per Nom o Correu Electrònic',
  createGroup: 'Crear grup',
  editGroup: 'Editar grup'
}
